import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';
import { roleGuard } from './core/guards/role.guard';
import { trialVencidoGuard } from './features/billing/guards/trial-vencido.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'contratantes',
    pathMatch: 'full',
  },

  // ── Auth routes (guest-only, layout mínimo) ───────────────────────────────
  {
    path: '',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./layout/auth-layout/auth-layout').then((m) => m.AuthLayout),
    children: [
      {
        path: 'auth',
        children: [
          {
            path: 'login',
            loadComponent: () =>
              import('./features/auth/login/login').then((m) => m.Login),
          },
          {
            path: 'verificar',
            loadComponent: () =>
              import('./features/auth/verify-otp/verify-otp').then((m) => m.VerifyOtp),
          },
          {
            path: '',
            redirectTo: 'login',
            pathMatch: 'full',
          },
        ],
      },
    ],
  },

  // ── Onboarding / Cadastro (guest-only, sem sidebar) ──────────────────────
  {
    path: 'cadastro',
    canActivate: [guestGuard],
    loadChildren: () =>
      import('./features/onboarding/onboarding.routes').then((m) => m.onboardingRoutes),
  },

  // ── Rotas protegidas (autenticado, shell completo) ────────────────────────
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/shell/shell').then((m) => m.Shell),
    children: [
      // Alias legado /inicio e /dashboard → /contratantes
      {
        path: 'inicio',
        redirectTo: 'contratantes',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        redirectTo: 'contratantes',
        pathMatch: 'full',
      },
      // Vagas — Admin e Recrutadora
      {
        path: 'vagas',
        canActivate: [roleGuard, trialVencidoGuard],
        data: { roles: ['admin', 'recrutadora'] },
        loadChildren: () =>
          import('./features/vagas/vagas.routes').then((m) => m.vagasRoutes),
      },
      // Candidatos (Pipeline) — Admin e Recrutadora
      {
        path: 'candidatos',
        canActivate: [roleGuard, trialVencidoGuard],
        data: { roles: ['admin', 'recrutadora'] },
        loadChildren: () =>
          import('./features/candidatos/candidatos.routes').then((m) => m.candidatosRoutes),
      },
      // Banco de Talentos — Admin e Recrutadora
      {
        path: 'banco-talentos',
        canActivate: [roleGuard, trialVencidoGuard],
        data: { roles: ['admin', 'recrutadora'] },
        loadChildren: () =>
          import('./features/banco-talentos/banco-talentos.routes').then(
            (m) => m.bancoTalentosRoutes,
          ),
      },
      // Contratantes (Clientes) — Admin e Recrutadora
      {
        path: 'contratantes',
        canActivate: [roleGuard, trialVencidoGuard],
        data: { roles: ['admin', 'recrutadora'] },
        loadChildren: () =>
          import('./features/clientes/clientes.routes').then((m) => m.clientesRoutes),
      },
      // Alias legado /carteira → /contratantes
      {
        path: 'carteira',
        redirectTo: 'contratantes',
        pathMatch: 'full',
      },
      // Alias legado /clientes → /contratantes
      {
        path: 'clientes',
        redirectTo: 'contratantes',
        pathMatch: 'full',
      },
      // Relatórios — Admin only
      {
        path: 'relatorios',
        canActivate: [roleGuard, trialVencidoGuard],
        data: { roles: ['admin'] },
        loadChildren: () =>
          import('./features/relatorios/relatorios.routes').then((m) => m.relatoriosRoutes),
      },
      // Configurações — Admin e Recrutadora (controle fino por sub-rota)
      {
        path: 'configuracoes',
        canActivate: [roleGuard, trialVencidoGuard],
        data: { roles: ['admin', 'recrutadora'] },
        loadChildren: () =>
          import('./features/configuracoes/configuracoes.routes').then(
            (m) => m.configuracoesRoutes,
          ),
      },
      // Billing — acessível a qualquer usuário autenticado, SEM trialVencidoGuard
      // (para que o usuário com trial vencido possa chegar aos planos)
      {
        path: 'billing',
        loadChildren: () =>
          import('./features/billing/billing.routes').then((m) => m.billingRoutes),
      },
      // Ajuda — acessível a qualquer usuário autenticado, sem guards de role/trial
      {
        path: 'ajuda',
        loadChildren: () =>
          import('./features/ajuda/ajuda.routes').then((m) => m.ajudaRoutes),
      },
      // Acesso negado
      {
        path: 'acesso-negado',
        loadComponent: () =>
          import('./features/acesso-negado/acesso-negado').then((m) => m.AcessoNegado),
      },
    ],
  },

  // ── Fallback ──────────────────────────────────────────────────────────────
  {
    path: '**',
    redirectTo: 'contratantes',
  },
];
